import { connect } from "react-redux";
import get from "lodash/get";

import getDates from "./../services/date.service";
import { handleChangeDataAnalyseTimeRange as onHandleChangeStore } from "../../actions/dataAnalyseTimeRangeActions";

const mapStateToProps = (state) => ({
  dataAnalyseTimeRangeDataState: state.dataAnalyseTimeRange.dataState,
  rangeStartDate: get(state, ["dataAnalyseTimeRange", "dataAnalyseTimeRange", "rangeStartDate"], getDates.getNullTimeDate(new Date())),
  rangeEndDate: get(state, ["dataAnalyseTimeRange", "dataAnalyseTimeRange", "rangeEndDate"], getDates.getNullTimeDate(new Date())),
  rangeStartTime: get(state, ["dataAnalyseTimeRange", "dataAnalyseTimeRange", "rangeStartTime"], getDates.getNullTimeDate(new Date())),
  rangeEndTime: get(state, ["dataAnalyseTimeRange", "dataAnalyseTimeRange", "rangeEndTime"], getDates.getEndDayTimeDate(new Date())),
});

const mapDispatchToProps = {
  onHandleChangeStore,
};

const withDataAnalyseTimeRange = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withDataAnalyseTimeRange };
